export default __webpack_public_path__ + "static/media/liquidationIcon.f01329bc.svg";